import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import { NamedLink } from '../../../components';

import css from './NoSearchResultsMaybe.module.css';

const NoSearchResultsMaybe = props => {
  const { listingsAreLoaded, totalItems, location, resetAll, showCreateListingsLink } = props;
  const hasNoResult = listingsAreLoaded && totalItems === 0;
  const hasSearchParams = location.search?.length > 0;

  const createListingLinkMaybe = showCreateListingsLink ? (
    <NamedLink className={css.createListingLink} name="NewListingPage">
      <FormattedMessage id="SearchPage.createListing" />
    </NamedLink>
  ) : null;

  const EmptyStateIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="m13.7 3.8 1 2.6a1.2 1.2 0 0 0 .7.7l2.6 1-2.6 1a1.2 1.2 0 0 0-.7.7l-1 2.6-1-2.6a1.2 1.2 0 0 0-.7-.7l-2.6-1 2.6-1a1.2 1.2 0 0 0 .7-.7l1-2.6Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m6.8 11.6.8 2.1c.1.2.2.4.5.5l2.1.8-2.1.8a.8.8 0 0 0-.5.5l-.8 2.1-.8-2.1a.8.8 0 0 0-.5-.5L3.4 15l2.1-.8c.2-.1.4-.2.5-.5l.8-2.1Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  return hasNoResult ? (
    <div className={css.noSearchResults}>
      <div className={css.iconWrap}>
        <EmptyStateIcon />
      </div>
      <div className={css.textWrap}>
        <p className={css.title}>
          <FormattedMessage id="SearchPage.emptyStateTitle" />
        </p>
        <p className={css.subtitle}>
          <FormattedMessage id="SearchPage.emptyStateSubtitle" />
        </p>
        {hasSearchParams || createListingLinkMaybe ? (
          <p className={css.actions}>
            {hasSearchParams ? (
              <button className={css.resetAllFiltersButton} onClick={e => resetAll(e)}>
                <FormattedMessage id={'SearchPage.resetAllFilters'} />
              </button>
            ) : null}
            {hasSearchParams && createListingLinkMaybe ? <span className={css.actionSep}>•</span> : null}
            {createListingLinkMaybe}
          </p>
        ) : null}
      </div>
    </div>
  ) : null;
};

export default NoSearchResultsMaybe;
